<script>

    import { toast } from 'bulma-toast'
    import { noticeStore, noticesStore, modalStore, adminStore } from '../stores'

    import NoticesService from '../$services/notices.service'
    import DateMethods from '../$methods/date.methods'

    import { isPermission } from '../$methods/permissions.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deleteNotice() {

        loading = true
        const resp = await NoticesService.deleteNotice($noticeStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        noticesStore.remove($noticeStore._id)
        modalStore.close()
    }

</script>

<div class="title is-4 mb-4">{ $noticeStore.title }</div>

{#if $noticeStore.type === 'image'}
    <div class="notice-media mb-4">
        {#if $noticeStore.link}
            <a href="{ $noticeStore.link }" target="_blank" rel="noopener noreferrer">
                <img src="{ $noticeStore.url }" alt="{ $noticeStore.type }">
            </a>
        {:else}
            <img src="{ $noticeStore.url }" alt="{ $noticeStore.type }">
        {/if}
    </div>
{/if}
{#if $noticeStore.type === 'video'}
    <div class="notice-media mb-4">
        {#if $noticeStore.link}
            <a href="{ $noticeStore.link }" target="_blank" rel="noopener noreferrer">
                <video controls><track kind="captions"><source src="{$noticeStore.url}" type="video/mp4"></video>
            </a>
        {:else}
            <video controls><track kind="captions"><source src="{$noticeStore.url}" type="video/mp4"></video>
        {/if}
    </div>
{/if}
{#if $noticeStore.type === 'text'}
    <div class="notice-text mb-4">{ $noticeStore.text }</div>
{/if}

<InfoCard subtitle="Detalle del aviso">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Tipo" icon="fas fa-tag" value={ $noticeStore.type } />
        <InfoField label="Display" icon="fas fa-desktop" value={ $noticeStore.display } />
        <InfoField label="Prioridad" icon="fas fa-sort-numeric-up" value={ $noticeStore.index } />
        <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($noticeStore.created) } />
        <InfoField label="Fecha de expiración" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($noticeStore.expired) } />
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'SettingsView.Notice.Delete') || isPermission($adminStore, 'UsersView.Notice.Delete')}
            <ButtonDelete on:confirm={deleteNotice} { loading } />
        {/if}
        {#if isPermission($adminStore, 'SettingsView.Notice.Update') || isPermission($adminStore, 'UsersView.Notice.Update')}
            <ButtonModal modalId="notice_update_modal" icon="edit" text="Actualizar" />
        {/if}
    </div>
</div>

<style>
    .notice-media,
    .notice-text {
        width: 100%;
        max-height: min(68vh, 680px);
    }

    .notice-media img,
    .notice-media video {
        display: block;
        width: 100%;
        max-height: min(68vh, 680px);
        object-fit: contain;
        background: #0f172a;
    }

    .notice-text {
        overflow-y: auto;
        padding: 3.5rem 4.5rem;
        text-align: center;
        white-space: pre-wrap;
        color: #1e2830;
        font-size: 1.15rem;
        line-height: 1.65;
    }

    :global(.is-dark) .notice-text {
        color: #f0f0f0;
    }

    .notice-text a {
        color: inherit;
        text-decoration: underline;
        text-underline-offset: 3px;
    }
</style>
